module.exports = "/assets/3af334fe862b70b2cbf79eab2692041c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KV.png
// module id = 1559
// module chunks = 0